import React, { useState } from 'react';
import { api, apiUrl, hoy } from '../../utils/api';
import { Spinner } from '../../components/UI';

export default function PasoCrear({ datos, onAnterior }) {
  const [creando, setCreando] = useState(false);
  const [ordenId, setOrdenId] = useState(null);
  const [error, setError] = useState('');
  const [fecha, setFecha] = useState(hoy());
  const [enviandoEmail, setEnviandoEmail] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);

  const { cliente, vehiculo, kilometraje, paquetes } = datos;
  const total = (paquetes || []).reduce((a, p) => a + (parseFloat(p.precio) || 0), 0);

  const crearOrden = async () => {
    setCreando(true); setError('');
    try {
      const res = await api('/ordenes/', {
        method: 'POST',
        body: JSON.stringify({
          id_cliente:  cliente.id,
          id_vehiculo: vehiculo.id,
          kilometraje: kilometraje ? parseInt(kilometraje) : null,
          fecha,
          resumen:     (paquetes[0]?.nombre || '').slice(0, 100),
          paquetes: paquetes.map((p, i) => ({
            nombre: p.nombre,
            precio: parseFloat(p.precio) || 0,
            tareas: p.tareas.map((t, j) => ({ ...t, orden_display: j })),
            repuestos: p.repuestos.map((r, j) => ({ ...r, orden_display: j })),
          })),
        })
      });
      setOrdenId(res.id);
    } catch (e) {
      setError(e.message);
    }
    setCreando(false);
  };

  const enviarPorEmail = async () => {
    setEnviandoEmail(true);
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 20000); // 20 segundos máximo
      const res = await fetch((process.env.REACT_APP_API_URL || '') + `/descargas/ordenes/${ordenId}/hoja-trabajo/enviar-email`, {
        method: 'POST', signal: controller.signal,
      });
      clearTimeout(timeoutId);
      if (!res.ok) throw new Error('No se pudo enviar');
      setEmailEnviado(true);
    } catch {
      alert('No se pudo enviar el email. Puede que el servidor de correo esté tardando demasiado — probá de nuevo en un rato.');
    }
    setEnviandoEmail(false);
  };

  if (ordenId) return (
    <div>
      <div style={{ textAlign: 'center', padding: '1.5rem 0 1rem' }}>
        <div style={{ fontSize: '3rem', marginBottom: '.5rem' }}>📋</div>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--azul)', marginBottom: '.25rem' }}>
          Orden creada — Borrador
        </h2>
        <p style={{ color: 'var(--gris-4)', fontSize: '.875rem' }}>{ordenId}</p>
      </div>

      <div className="card" style={{ marginBottom: '1rem', background: 'var(--gris-1)' }}>
        <p style={{ fontSize: '.875rem', color: 'var(--gris-5)', lineHeight: 1.6 }}>
          Imprimí esta hoja para llevar al taller. Cuando termines el trabajo, vas a la sección
          <strong> Órdenes</strong>, abrís esta orden y la <strong>cerrás</strong> completando
          kilometraje, escaneo y batería — ahí se genera el documento final para el cliente.
        </p>
      </div>

      <a href={apiUrl(`/descargas/ordenes/${ordenId}/hoja-trabajo`)}
        className="btn btn-primary btn-full" target="_blank" rel="noreferrer">
        🖨️ Imprimir hoja de trabajo
      </a>

      <button className="btn btn-outline btn-full" style={{ marginTop: '.6rem' }}
        disabled={enviandoEmail || emailEnviado} onClick={enviarPorEmail}>
        {emailEnviado ? '✅ Enviado a iunicmotors@gmail.com' : enviandoEmail ? 'Enviando...' : '📧 Enviar por email'}
      </button>

      <button className="btn btn-secondary btn-full" style={{ marginTop: '.75rem' }}
        onClick={() => window.location.reload()}>
        + Nueva orden
      </button>
    </div>
  );

  return (
    <div>
      <div className="sec-header">
        <h2 className="sec-title">Crear orden</h2>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <p style={{ fontWeight: 600, color: 'var(--azul)', marginBottom: '.6rem' }}>Resumen</p>
        <div className="resumen-grid">
          <div className="resumen-card"><div className="label">Cliente</div><div className="valor">{cliente?.nombre}</div></div>
          <div className="resumen-card"><div className="label">Vehículo</div><div className="valor">{vehiculo?.marca} {vehiculo?.modelo}</div></div>
          <div className="resumen-card"><div className="label">Matrícula</div><div className="valor">{vehiculo?.matricula || '—'}</div></div>
        </div>
        <div className="form-group" style={{ marginTop: '.9rem', maxWidth: 220 }}>
          <label className="form-label">Fecha del trabajo</label>
          <input type="date" className="form-input" value={fecha} onChange={e => setFecha(e.target.value)} />
        </div>
      </div>

      {(paquetes || []).map((p, i) => (
        <div key={i} className="card" style={{ marginBottom: '.75rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.4rem' }}>
            <p style={{ fontWeight: 600 }}>{p.nombre}</p>
            <p style={{ fontWeight: 700 }}>${(parseFloat(p.precio) || 0).toLocaleString()}</p>
          </div>
          {p.tareas.map((t, j) => (
            <p key={j} style={{ fontSize: '.8125rem', color: 'var(--gris-5)' }}>• {t.descripcion}</p>
          ))}
        </div>
      ))}

      <div style={{
        background: 'var(--azul)', color: 'white', borderRadius: 'var(--radio)',
        padding: '.75rem 1.25rem', display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: '1rem', fontWeight: 600
      }}>
        <span>TOTAL ESTIMADO</span>
        <span>${total.toLocaleString('es-UY', { maximumFractionDigits: 0 })}</span>
      </div>

      {error && <p style={{ color: 'var(--rojo)', marginBottom: '.75rem', fontSize: '.875rem' }}>{error}</p>}
      {creando && <Spinner texto="Creando orden..." />}

      <div style={{ display: 'flex', gap: '.5rem' }}>
        <button className="btn btn-secondary" onClick={onAnterior} disabled={creando}>← Atrás</button>
        <button className="btn btn-primary" style={{ flex: 1 }} disabled={creando} onClick={crearOrden}>
          ✅ Aceptar y crear orden (borrador)
        </button>
      </div>
    </div>
  );
}
